(ns iris.websocket.client
  (:require [re-frame.core :as rf]))

(defonce ws-connection (atom nil))
(defonce reconnect-timer (atom nil))

(defn connect! 
  "Connect to WebSocket server with token"
  [url token on-message on-close]
  (when @ws-connection
    (.close @ws-connection))
  
  (let [ws-url (str url "?token=" token)
        ws (js/WebSocket. ws-url)]
    
    (set! (.-onopen ws)
      (fn []
        (js/console.log "WebSocket connected")
        (rf/dispatch [:iris.websocket/connected])))
    
    (set! (.-onmessage ws)
      (fn [e]
        (try
          (let [data (js/JSON.parse (.-data e))
                msg (js->clj data :keywordize-keys true)]
            (on-message msg))
          (catch js/Error err
            (js/console.error "Failed to parse WebSocket message:" err)))))
    
    (set! (.-onerror ws)
      (fn [e]
        (js/console.error "WebSocket error:" e)
        (rf/dispatch [:iris.websocket/error e])))
    
    (set! (.-onclose ws)
      (fn []
        (js/console.log "WebSocket closed")
        (on-close)))
    
    (reset! ws-connection ws)
    ws))

(defn send! 
  "Send message through WebSocket"
  [message]
  (when-let [ws @ws-connection]
    (when (= (.-readyState ws) js/WebSocket.OPEN)
      (let [json-str (js/JSON.stringify (clj->js message))]
        (js/console.log "Sending JSON:" json-str)
        (.send ws json-str)))))

(defn disconnect! 
  "Close WebSocket connection"
  []
  (when @reconnect-timer
    (js/clearTimeout @reconnect-timer)
    (reset! reconnect-timer nil))
  (when-let [ws @ws-connection]
    (.close ws)
    (reset! ws-connection nil)))

(defn connected? 
  "Check if WebSocket is connected"
  []
  (when-let [ws @ws-connection]
    (= (.-readyState ws) js/WebSocket.OPEN)))